const georgian = {
  default: [
    "„ 1 2 3 4 5 6 7 8 9 0 - = {bksp}",
    "{tab} ქ წ ე რ ტ ყ უ ი ო პ [ ] \\",
    "{lock} ა ს დ ფ გ ჰ ჯ კ ლ ; ' {enter}",
    "{shift} ზ ხ ც ვ ბ ნ მ , . / {shift}",
    ".com @ {space}"
  ],
  shift: [
    "“ ! @ # $ % ^ & * ( ) _ + {bksp}",
    "{tab} ქ ჭ ე ღ თ ყ უ ი ო პ { } | ~",
    '{lock} ა შ დ ფ გ ჰ ჟ კ ₾ : " {enter}',
    "{shift} ძ ხ ჩ ვ ბ ნ მ < > ? {shift}",
    ".com @ {space}"
  ]
};

export default georgian;
